import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import { PM_V2_Template_Interface } from '../../../Interface/PM_V2_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-pm-v2-template-list',
  templateUrl: './PM_V2_TemplateList.component.html',
  styleUrls: ['./PM_V2_TemplateList.component.css']
})
export class PM_V2_TemplateListComponent implements OnInit {

  Data_Seleted_Delete: any
  DataList: PM_V2_Template_Interface[] = [];
  Procssing: boolean = false;
  SearchText: string = '';

  page: number = 0;
  constructor(
    private PM_V2_Service: PM_V2_Service,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
    private router: Router,
    private Nav_Service: NavService,
  ) { }

  ngOnInit(): void {
    this.Nav_Service.CheckValidPage(2238).subscribe(
      data => {
        this.ReadData();
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

  ReadData() {
    this.Procssing = true;

    this.PM_V2_Service.GetTemplate().subscribe(
      data => {
        this.DataList = data || [];
        this.Procssing = false;
      },
      error => this.HandleError(error)
    );
  }

  Add() {
    this.router.navigate(['/pm-v2/template/add']);
  }

  Edit(id: number) {
    this.router.navigate(['/pm-v2/template/edit', id]);
  }

  get FilteredList(): PM_V2_Template_Interface[] {
    const key = (this.SearchText || '').trim().toLowerCase();

    if (!key) {
      return this.DataList;
    }

    return this.DataList.filter(x =>
      (x.PM_Code || '').toLowerCase().indexOf(key) >= 0 ||
      (x.PM_Title || '').toLowerCase().indexOf(key) >= 0 ||
      String(x.Version == null ? '' : x.Version).indexOf(key) >= 0
    );
  }

  private HandleError(error: any) {
    this.Procssing = false;

    if (error && error.status === 404) {
      //localStorage.clear();
      //location.reload();
      return;
    }

    this.Alertify_Service.ErrorMessage('خطا در دریافت اطلاعات.');
  }



  Delete(item: any) {
    item.DeletingProccess = true
    this.modalRef_Delete.hide()
    this.PM_V2_Service.DeleteTemplate(item.id).subscribe(
      data => {
        if (item.del == false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  modalRef_Delete: any;
  openModal(template: TemplateRef<any>, Record: any) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
